export default{
	// API_URL :'http://localhost:8000/' , //API_URL 
	API_URL :'https://api-django-blog.up.railway.app/' , //API_URL 
	// API_URL : 'https://m-fake-rest-api-nodejs.herokuapp.com'
	// API_URL : 'https://api-blog-app.up.railway.app/'
}